import { CampoInformacion } from "../../shared";
import { Divider } from "primereact/divider";

// Etiquetas de los campos conocidos de "Empresas Intervinientes" de Penta.
// Un campo que no esté acá se muestra igual, con su clave como etiqueta.
const ETIQUETAS = {
  ruc: "RUC",
  direccion: "Dirección",
  telefono: "Teléfono",
  despachante: "Despachante"
};

/**
 * Datos de contacto crudos de la operación (Importacion.datosContacto), un
 * CampoInformacion por dato. Los campos en null se omiten; si no queda
 * ninguno, la sección entera no se muestra.
 */
export default function DatosContacto({ datosContacto }) {
  const datos = Object.entries(datosContacto || {}).filter(
    ([, valor]) => valor !== null && valor !== undefined && valor !== ""
  );

  if (datos.length === 0) return null;

  return (
    <>
      <Divider />
      <div className="grid">
        {datos.map(([clave, valor]) => (
          <CampoInformacion key={clave} nombreCampo={ETIQUETAS[clave] || clave}>
            {String(valor)}
          </CampoInformacion>
        ))}
      </div>
    </>
  );
}
